import React from 'react';
import {useLocation} from 'react-router-dom';
import {orgId, platform} from '../../context/context';
import MenuEntry from './menu-entry';

const Menu = () => {

  const location = useLocation();

  const isShopify = platform === 'SHOPIFY';

  const buildLink = path => path + (orgId ? '?shop=' + orgId : '');

  const menuItems = () => <>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"/>
    </button>
    <div className="collapse navbar-collapse" id="navbarContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        {isShopify && <MenuEntry link={buildLink('/instructions')}>Instructions</MenuEntry>}
        <MenuEntry link={buildLink('/forms')}>Forms</MenuEntry>
        <MenuEntry link={buildLink('/submissions')}>Submissions</MenuEntry>
        <MenuEntry link={buildLink('/notifications')}>Notifications</MenuEntry>
        <li className="nav-item dropdown">
          <a href="#"
             className="nav-link dropdown-toggle"
             id="integrationsDropdown"
             data-bs-toggle="dropdown" aria-expanded="false" role="button">
            Integrations
          </a>
          <ul className="dropdown-menu" aria-labelledby="integrationsDropdown">
            <MenuEntry dropdownItem={true} link={buildLink('/integrations/dropbox')}>
              Dropbox
            </MenuEntry>
            <MenuEntry dropdownItem={true} link={buildLink('/integrations/google-drive')}>
              Google Drive
            </MenuEntry>
            <MenuEntry dropdownItem={true} link={buildLink('/integrations/google-sheets')}>
              Google Sheets
            </MenuEntry>
            <MenuEntry dropdownItem={true} link={buildLink('/integrations/recaptcha')}>
              reCAPTCHA
            </MenuEntry>
            {isShopify &&
              <MenuEntry dropdownItem={true} link={buildLink('/integrations/shopify')}>
                Shopify
              </MenuEntry>
            }
            <MenuEntry dropdownItem={true} link={buildLink('/integrations/zapier')}>
              Zapier
            </MenuEntry>
          </ul>
        </li>
        {isShopify && <MenuEntry link={buildLink('/billing/plans')}>Subscription</MenuEntry>}
        {isShopify && <MenuEntry link={buildLink('/get-in-touch')}>Get in touch</MenuEntry>}
      </ul>
    </div>
  </>;

  return <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
    <div className="container">
      {location.pathname === '/' ?
        <div className="navbar-brand">Acerill Forms</div> :
        menuItems()
      }
    </div>
  </nav>;
};

export default Menu;
